import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a7b73c5bedae7001412c0ce_1787247468999_029e5ae0/arenasync/src/app/page.tsx");
